import React from "react";
import { connect } from "react-redux";
import { PrivyProvider } from "@privy-io/react-auth";
import { SmartWalletsProvider } from "@privy-io/react-auth/smart-wallets";
import appConfig from "config.json";
import { getCustomToken } from "utils/auth";
import WalletProvider from "./WalletWrapper";

// Check if running on HTTPS (required for Privy embedded wallet)
const isHttps = typeof window !== "undefined" && (window.location.protocol === "https:" || window.location.hostname === "localhost");

// Conditional Privy wrapper that only renders when user is logged in and crypto features are enabled
const PrivyWrapper = ({ children, jwtToken, loggedIn }) => {
  const getCustomAccessToken = async () => {
    const wallet = getCustomToken();
    return wallet;
  };

  // Skip Privy on non-HTTPS connections (except localhost)
  if (!isHttps) {
    console.log("Privy disabled - HTTPS required for embedded wallet");
    return <WalletProvider>{children}</WalletProvider>;
  }

  // If crypto features are disabled, render children without Privy
  if (!appConfig.config.bc_privy_app_id || !appConfig.config.bc_privy_app_zerodev_project_id) {
    console.log("Crypto wallet features disabled - rendering without Privy providers");
    return <WalletProvider>{children}</WalletProvider>;
  }

  // If user is not logged in, render children without Privy
  if (!loggedIn || !jwtToken) {
    return children;
  }

  // If user is logged in and crypto features enabled, wrap with Privy providers
  return (
    <PrivyProvider
      appId={appConfig.config.bc_privy_app_id}
      config={{
        customAuth: {
          isLoading: !jwtToken,
          getCustomAccessToken,
        },
      }}
    >
      <SmartWalletsProvider>
        <WalletProvider>{children}</WalletProvider>
      </SmartWalletsProvider>
    </PrivyProvider>
  );
};

export default connect((state) => ({
  jwtToken: state.getIn(["users", "user", "token"]),
  loggedIn: state.getIn(["users", "user", "loggedIn"]),
}))(PrivyWrapper);
